import { useEffect, useRef } from 'react';
import { useAppStore } from '../../../store/appStore';

export function useAiTerminalSettingsSync() {
  const settings = useAppStore((state) => state.aiTerminalSettings);
  const lastSentJsonRef = useRef<string | null>(null);

  useEffect(() => {
    const api = window.electronAPI?.aiWorkspace;
    if (!api?.updateSettings) return;

    const nextJson = JSON.stringify(settings);
    if (lastSentJsonRef.current === nextJson) return;
    lastSentJsonRef.current = nextJson;

    api.updateSettings(settings).catch((error) => {
      console.error('[AiTerminalSettingsSync] Failed to update main-process settings:', error);
    });
  }, [settings]);
}

